import { createValidator, length, maxLength, required } from 'util/validation'

import { CadastrarDispositivoPainelChamadasModel } from '../model-chamadaPainel'

export const cadastrarDispositivoPainelValidator = createValidator<CadastrarDispositivoPainelChamadasModel>({
  nome: [required, maxLength(50)],
  codigo: [required, length(4)],
})
